import { render, staticRenderFns } from "./EditOrderModifier.vue?vue&type=template&id=ed5d9084&scoped=true&"
import script from "./EditOrderModifier.vue?vue&type=script&lang=js&"
export * from "./EditOrderModifier.vue?vue&type=script&lang=js&"
import style0 from "./EditOrderModifier.vue?vue&type=style&index=0&id=ed5d9084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5d9084",
  null
  
)

export default component.exports